import changeFileExtension from '@/lib/filename-extension-modifier'

const generateMagazineImage = (images) => {
  const getImage = (context, ratio, size) =>
    images?.[`${context}_${ratio}_${size}`]?.[0]
  const largeSrcSet = [
    {
      width: 300,
      src: changeFileExtension(getImage('cover', '321x446', 300)?.url, 'webp')
    },
    {
      width: 150,
      src: changeFileExtension(getImage('cover', '321x446', 150)?.url, 'webp')
    }
  ]
  const smallSrcSet = [
    {
      width: 270,
      src: changeFileExtension(getImage('cover', '321x446', 270)?.url, 'webp')
    },
    {
      width: 150,
      src: changeFileExtension(getImage('cover', '321x446', 150)?.url, 'webp')
    }
  ]

  const image = {
    desktop: {
      srcSet: largeSrcSet,
      alt: 'Magazine Cover Image',
      sizes: ['min-width(960px) 50vw', '100vw'],
      src: getImage('cover', '321x446', 300)?.url
    },
    mobile: {
      srcSet: smallSrcSet,
      alt: 'Magazine Cover Image',
      sizes: ['min-width(960px) 50vw', '100vw'],
      src: getImage('cover', '321x446', 150)?.url
    }
  }

  return image
}

export default generateMagazineImage
